<template>
  <div
    class="new-song-on-list"
    v-if="songs"
  >
    <div class="new-song-on-list__title">
      nowości w nagraniach do głosowania
    </div>
    <div
      class="new-song-on-list__songs-container"
    >
      <div
        class="new-song-on-list__single-song"
        v-for="(listItem, index) in songs"
        :key="index + '__new-song'"
      >
        <div
          class="new-song-on-list__single-song-container"
          v-if="index <= songEl"
        >
          <!-- <div
            class="new-song-on-list__single-song-photo"
            v-if="listItem.artists"
            :class="{photoContentWithoutPhoto: !listItem.artists[0].photo}"
            v-bind:style="{ backgroundImage: 'url('  + listItem.artists[0].photo +  ')' }"
          >
          </div> -->
          <div class="new-song-on-list__single-song-data">
            <div>
              <div
                class="new-song-on-list__single-song-author"
                v-if="listItem.artists"
                @click="()=>{goToArtistSite(listItem.artists[0].id)}"
              >
                {{listItem.artists[0].name}}
              </div>
              <div
                class="new-song-on-list__single-song-title"
                @click="()=>{goToSong(listItem.id)}"
              >
                {{listItem.name}}
              </div>
            </div>
            <div class="new-song-on-list__info-button">
              <i
                v-if="listItem.mp3Path !== '' && listItem.mp3Path === actualPlay && isPlaying"
                class="material-icons"
                @click="playMP3(listItem.mp3Path)"
              >
                pause_circle_outline
              </i>
              <i
                v-if="listItem.mp3Path !== '' && listItem.mp3Path === actualPlay && !isPlaying"
                class="material-icons"
                @click="playMP3(listItem.mp3Path)"
              >
                play_circle_outline
              </i>
              <i
                v-if="listItem.mp3Path !== '' && listItem.mp3Path !== actualPlay"
                class="material-icons"
                @click="playMP3(listItem.mp3Path)"
              >
                play_circle_outline
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="new-song-on-list__show-more-button"
      v-if="showAll && songsElements !== newSongs.length"
    >
      <SelectButtonMobile
        buttonName="zobacz wszystkie nowości"
        :action="()=>{showAllSongs()}"
      />
    </div>
  </div>
</template>

<script>
import mixin from '../mixin';
import SelectButtonMobile from '@/ui/SelectButtonMobile.vue';

export default {
  mixins: [mixin],
  components: {
    SelectButtonMobile
  }
}
</script>

<style scoped lang="scss">
.new-song-on-list {
  margin-top: 1rem;
  max-width: 700px;
  &__title {
    background-color: #df2860;
    font-size: 1.2rem;
    text-transform: uppercase;
    height: 2.5rem;
    font-weight: 700;
    font-family: 'Poppins', sans-serif;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fefefe;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 0.6rem;
  }
  &__single-song {
    font-family: 'Poppins', sans-serif;
    &:last-child {
      border-bottom:unset;
    }
  }
  &__single-song-container {
    display: flex;
    padding: 1rem 1rem;
    background-color: #e6e6ed;

    border-bottom: 1px solid #d0d0e0;
  }
  &__single-song-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1rem;
    line-height: 1.2;
    color: #0f1626;
    cursor: pointer;
  }
  &__single-song-author {
    font-family: 'Poppins', sans-serif;
    color: #0f1626;
    font-size: 1.5rem;
    line-height: 1.2;
    font-weight: 700;
    padding: 0 2rem 0.3rem 0;
    cursor: pointer;
  }
  &__info-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
      color: #df2860;
      font-size: 3rem;
      cursor: pointer;
    }
  }
  &__single-song-photo {
    width: 7.5rem;
    height: 4.6875rem;
    box-sizing: border-box;
    border: 1px solid #e13368;
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    margin-right: 1rem;
  }
  &__show-more-button {
    background-color: #fefefe;
    padding: 1rem 3rem;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    .select-button{
      font-size: 1rem;
    }
  }
  &__single-song-data {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .photoContentWithoutPhoto {
    background-image: url('/img/zaslepa.jpg') !important;
  }
}
</style>
